import { useI18nContext } from "./useI18nContext";

/**
 * Returns formatFullName function that takes a person's given name surname, and returns
 * a concatenated version that's appropriate for the current locale.
 *
 * TODO: Currently only Japanese is treated differently, putting the surname first.
 * All other languages currently use the standard format of putting the given name first.
 */
export function useI18nName() {
  const { language } = useI18nContext();

  type Options = Record<never, never>;
  const formatFullName = (
    name:
      | { givenName: string; surname: string }
      | {
          first: string;
          middle?: string;
          last: string;
        },
    options?: Options
  ) => {
    const internalName =
      "givenName" in name
        ? { first: name.givenName, last: name.surname }
        : { ...name };

    switch (language.toLowerCase()) {
      case "ja":
        return `${internalName.last} ${internalName.first}`;
      default:
        return `${internalName.first} ${internalName.last}`;
    }
  };

  return { formatFullName };
}
